import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "scopeaccess-tree"
  }, [_c(VTextField, {
    staticClass: "pa-2",
    attrs: {
      "label": _vm.$i18n_t('Common.search'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "clearable": "",
      "hide-details": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  }), _vm.isLoading ? [_c(VOverlay, {
    attrs: {
      "absolute": "",
      "value": _vm.isLoading
    }
  }, [_c(VProgressCircular, {
    attrs: {
      "color": _vm.color,
      "indeterminate": "",
      "width": "5",
      "size": "80",
      "rotate": "-90"
    }
  })], 1)] : _vm._e(), !_vm.isLoading && _vm.fetchError === 'TOO_MANY_RESULTS' ? [_c('div', {
    staticClass: "px-4 pt-6"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.tooManyResults')) + "\n    ")])] : !_vm.isLoading && _vm.scopeTree.length === 0 ? [_c('div', {
    staticClass: "px-4 pt-6"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.noResults')) + "\n    ")])] : [_c('div', {
    class: _vm.isLoading ? 'tree-is-loading' : undefined
  }, [_c('div', {
    staticClass: "mx-3"
  }, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": _vm.color
    }
  }, [_vm._v("fal fa-user-friends")]), _c('span', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.tenantScope')))]), _c(VIcon, {
    staticClass: "mx-1",
    attrs: {
      "small": "",
      "color": _vm.color
    }
  }, [_vm._v("fal fa-key")]), _c('span', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.twinScope')))])], 1), _c(VTreeview, {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "items": _vm.scopeTree,
      "selectable": false,
      "activatable": false,
      "disabled": _vm.isLoading,
      "load-children": _vm.fetchChildren,
      "open": _vm.openItems,
      "expand-icon": "fal fa-angle-down",
      "item-text": "name",
      "transition": "",
      "hoverable": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function ({
        item
      }) {
        return [_vm.itemType(item) !== _vm.itemTypeLoadMore ? [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + " " + _vm._s(item.id) + ")")] : _vm._e()];
      }
    }, {
      key: "prepend",
      fn: function ({
        item
      }) {
        return [_vm.itemType(item) !== _vm.itemTypeLoadMore ? [_c(VIcon, {
          class: _vm.color + '--text ml-2',
          staticStyle: {
            "width": "30px"
          },
          attrs: {
            "size": "24"
          },
          domProps: {
            "textContent": _vm._s(`${_vm.getScopeTreeIcon(item)}`)
          }
        })] : _vm.itemType(item) === _vm.itemTypeLoadMore ? [_c('div', {
          staticClass: "load-more"
        }, [_c(VBtn, {
          class: `v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.fetchChildren(item);
            }
          }
        }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")])], 1)] : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [_vm.itemType(item) !== _vm.itemTypeLoadMore ? [_c('div', {
          class: _vm.itemLabelClass(item),
          on: {
            "click": function ($event) {
              return _vm.selectedScope(item);
            }
          }
        }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])] : _vm._e()];
      }
    }])
  })], 1)]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };